import React from "react";
import { push as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Item from "./Item";
import ItemExternal from "./ItemExternal";

import HeraSolutionsLogo from "../../../assets/images/pv2-images/heraa-two-tone.png";

const Sidebar = ({
  isOpen,
  outerContainerId,
  pageWrapId,
  setActiveSidebar,
  items,
  setSsoRefreshTokenModal,
  refreshToken,
}) => {
  const isMenuOpen = (state) => {
    setActiveSidebar(state.isOpen);
  };
  const { t } = useTranslation();

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  return (
    <Menu
      customBurgerIcon={false}
      isOpen={isOpen}
      outerContainerId={outerContainerId}
      pageWrapId={pageWrapId}
      width={288}
      onStateChange={isMenuOpen}
      className=""
    >
      <div className="sidebar-brand">
        <Link to={"/"} className="sidebar-brand__link">
          <img
            src={HeraSolutionsLogo}
            alt="Hera Solutions"
            className="menu-logo"
          />
        </Link>
        <p className="text-center">Employee workspace</p>
      </div>

      <div className="sidebar-user">
        <span className="sidebar-user__avatar" aria-hidden="true">
          {(user?.first_name || "A").charAt(0).toUpperCase()}
        </span>
        <span>
          <strong>{user?.first_name || "Employee"}</strong>
          <small>{user?.email || "Your account"}</small>
        </span>
      </div>

      <p className="sidebar-section-label">Workspace</p>

      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.external ? (
            <ItemExternal
              key={index}
              item={item}
              setSsoRefreshTokenModal={setSsoRefreshTokenModal}
              setActiveSidebar={setActiveSidebar}
              refreshToken={refreshToken}
            />
          ) : (
            <Item key={index} item={item} t={t} />
          )}
        </React.Fragment>
      ))}

      <div className="sidebar-footer">
        <Link to="/setting" className="sidebar-footer__link">
          <i className="fas fa-sliders-h" aria-hidden="true" />
          <span>Settings</span>
        </Link>
        <Link to="/logout" className="sidebar-footer__link sidebar-footer__link--danger">
          <i className="fas fa-sign-out-alt" aria-hidden="true" />
          <span>Sign out</span>
        </Link>
      </div>
    </Menu>
  );
};

export default Sidebar;
